import "./index.css";

export default function PercentageBar({currentPercentage}){
    function defineColorByPercentage(){
        if(parseInt(currentPercentage) <= 15){
            return "rgb(201, 0, 0)";
        }

        if(parseInt(currentPercentage) > 15 && parseInt(currentPercentage) <= 66){
            return "rgb(255, 215, 14)";
        }

        if(parseInt(currentPercentage) >= 66 && parseInt(currentPercentage) <= 100){
            return "rgb(78, 213, 78)";
        }

        if(parseInt(currentPercentage) > 100){
            return "rgb(255, 115, 0)";
        }
    }

    function defineWidthByPercentage(){
        return `${parseInt(currentPercentage)}%`;
    }

    return (
        <div className="percentage-bar" style={{border: `1px solid ${defineColorByPercentage()}`}}>
            <div className="percentage-bar__filled-space" style={{width: `${defineWidthByPercentage()}`, backgroundColor: `${defineColorByPercentage()}`}}></div>
            <span className="percentage-bar__value">{parseInt(currentPercentage)}%</span>
        </div>
    )
}